var map = {
	"./jobs/jobs.module": [
		"./src/app/views/setting/jobs/jobs.module.ts",
		"jobs.module"
	],
	"./views/base/base.module": [
		"./src/app/views/base/base.module.ts",
		"common",
		"base.module"
	],
	"./views/buttons/buttons.module": [
		"./src/app/views/buttons/buttons.module.ts",
		"buttons.module"
	],
	"./views/chartjs/chartjs.module": [
		"./src/app/views/chartjs/chartjs.module.ts",
		"chartjs.module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./views/fin/account_report/account_report.module": [
		"./src/app/views/fin/account_report/account_report.module.ts",
		"account_report.module"
	],
	"./views/fin/accountbranches/accountbranches.module": [
		"./src/app/views/fin/accountbranches/accountbranches.module.ts",
		"accountbranches.module"
	],
	"./views/fin/accounts/accounts.module": [
		"./src/app/views/fin/accounts/accounts.module.ts",
		"accounts.module"
	],
	"./views/fin/additionals/additionals.module": [
		"./src/app/views/fin/additionals/additionals.module.ts",
		"additionals.module"
	],
	"./views/fin/costcenters/costcenters.module": [
		"./src/app/views/fin/costcenters/costcenters.module.ts",
		"costcenters.module"
	],
	"./views/fin/expense_vouchers/expense_vouchers.module": [
		"./src/app/views/fin/expense_vouchers/expense_vouchers.module.ts",
		"expense_vouchers.module"
	],
	"./views/fin/journals/journals.module": [
		"./src/app/views/fin/journals/journals.module.ts",
		"journals.module"
	],
	"./views/fin/openingbalances/openingbalances.module": [
		"./src/app/views/fin/openingbalances/openingbalances.module.ts",
		"openingbalances.module"
	],
	"./views/fin/post_accounts/post_accounts.module": [
		"./src/app/views/fin/post_accounts/post_accounts.module.ts",
		"post_accounts.module"
	],
	"./views/fin/reciept_vouchers/reciept_vouchers.module": [
		"./src/app/views/fin/reciept_vouchers/reciept_vouchers.module.ts",
		"reciept_vouchers.module"
	],
	"./views/fin/total_report/total_report.module": [
		"./src/app/views/fin/total_report/total_report.module.ts",
		"total_report.module"
	],
	"./views/icons/icons.module": [
		"./src/app/views/icons/icons.module.ts",
		"icons.module"
	],
	"./views/mainsystem/mainsystem.module": [
		"./src/app/views/mainsystem/mainsystem.module.ts",
		"common",
		"mainsystem.module"
	],
	"./views/management/distribution/distribution.module": [
		"./src/app/views/management/distribution/distribution.module.ts",
		"common",
		"distribution.module.0"
	],
	"./views/management/distribution_departments/distribution.module": [
		"./src/app/views/management/distribution_departments/distribution.module.ts",
		"common",
		"distribution.module"
	],
	"./views/management/processes/processes.module": [
		"./src/app/views/management/processes/processes.module.ts",
		"processes.module"
	],
	"./views/management/taskpost/taskpost.module": [
		"./src/app/views/management/taskpost/taskpost.module.ts",
		"common",
		"taskpost.module"
	],
	"./views/management/tasks/tasks.module": [
		"./src/app/views/management/tasks/tasks.module.ts",
		"common",
		"tasks.module"
	],
	"./views/notifications/notifications.module": [
		"./src/app/views/notifications/notifications.module.ts",
		"common",
		"notifications.module"
	],
	"./views/pages/pages.module": [
		"./src/app/views/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"./views/permission/permission.module": [
		"./src/app/views/permission/permission.module.ts",
		"permission.module"
	],
	"./views/pos/invoices/invoices.module": [
		"./src/app/views/pos/invoices/invoices.module.ts",
		"invoices.module"
	],
	"./views/pos/itemlists/itemlists.module": [
		"./src/app/views/pos/itemlists/itemlists.module.ts",
		"itemlists.module"
	],
	"./views/pos/pos.module": [
		"./src/app/views/pos/pos.module.ts",
		"common",
		"pos.module"
	],
	"./views/pos/returninvoices/returninvoices.module": [
		"./src/app/views/pos/returninvoices/returninvoices.module.ts",
		"returninvoices.module"
	],
	"./views/pro/depreciation/depreciation.module": [
		"./src/app/views/pro/depreciation/depreciation.module.ts",
		"common",
		"depreciation.module"
	],
	"./views/pro/exchange/exchange.module": [
		"./src/app/views/pro/exchange/exchange.module.ts",
		"common",
		"exchange.module"
	],
	"./views/pro/inventory/inventory.module": [
		"./src/app/views/pro/inventory/inventory.module.ts",
		"common",
		"inventory.module"
	],
	"./views/pro/itemsquantity/itemsquantity.module": [
		"./src/app/views/pro/itemsquantity/itemsquantity.module.ts",
		"itemsquantity.module"
	],
	"./views/pro/itemstransactions/itemstransactions.module": [
		"./src/app/views/pro/itemstransactions/itemstransactions.module.ts",
		"itemstransactions.module"
	],
	"./views/pro/purchases/purchases.module": [
		"./src/app/views/pro/purchases/purchases.module.ts",
		"purchases.module"
	],
	"./views/pro/refunds/refunds.module": [
		"./src/app/views/pro/refunds/refunds.module.ts",
		"refunds.module"
	],
	"./views/setting/archive/archive.module": [
		"./src/app/views/setting/archive/archive.module.ts",
		"archive.module"
	],
	"./views/setting/banks/banks.module": [
		"./src/app/views/setting/banks/banks.module.ts",
		"banks.module"
	],
	"./views/setting/branches/branches.module": [
		"./src/app/views/setting/branches/branches.module.ts",
		"branches.module"
	],
	"./views/setting/branches_settings/branches_settings.module": [
		"./src/app/views/setting/branches_settings/branches_settings.module.ts",
		"branches_settings.module"
	],
	"./views/setting/cities/cities.module": [
		"./src/app/views/setting/cities/cities.module.ts",
		"common",
		"cities.module"
	],
	"./views/setting/classifications/classifications.module": [
		"./src/app/views/setting/classifications/classifications.module.ts",
		"classifications.module"
	],
	"./views/setting/currencies/currencies.module": [
		"./src/app/views/setting/currencies/currencies.module.ts",
		"currencies.module"
	],
	"./views/setting/customers/customers.module": [
		"./src/app/views/setting/customers/customers.module.ts",
		"common",
		"customers.module"
	],
	"./views/setting/departments/departments.module": [
		"./src/app/views/setting/departments/departments.module.ts",
		"departments.module"
	],
	"./views/setting/employees/employees.module": [
		"./src/app/views/setting/employees/employees.module.ts",
		"employees.module"
	],
	"./views/setting/fields/fields.module": [
		"./src/app/views/setting/fields/fields.module.ts",
		"fields.module"
	],
	"./views/setting/items/items.module": [
		"./src/app/views/setting/items/items.module.ts",
		"items.module"
	],
	"./views/setting/itemsGroups/itemsGroups.module": [
		"./src/app/views/setting/itemsGroups/itemsGroups.module.ts",
		"itemsGroups.module"
	],
	"./views/setting/jobs/jobs.module": [
		"./src/app/views/setting/jobs/jobs.module.ts",
		"jobs.module"
	],
	"./views/setting/members/members.module": [
		"./src/app/views/setting/members/members.module.ts",
		"members.module"
	],
	"./views/setting/organization/organization.module": [
		"./src/app/views/setting/organization/organization.module.ts",
		"organization.module"
	],
	"./views/setting/permissions/permissions.module": [
		"./src/app/views/setting/permissions/permissions.module.ts",
		"permissions.module"
	],
	"./views/setting/setting.module": [
		"./src/app/views/setting/setting.module.ts",
		"common",
		"setting.module"
	],
	"./views/setting/stores/stores.module": [
		"./src/app/views/setting/stores/stores.module.ts",
		"stores.module"
	],
	"./views/setting/suppliers/suppliers.module": [
		"./src/app/views/setting/suppliers/suppliers.module.ts",
		"suppliers.module"
	],
	"./views/setting/taxes/taxes.module": [
		"./src/app/views/setting/taxes/taxes.module.ts",
		"taxes.module"
	],
	"./views/setting/users/users.module": [
		"./src/app/views/setting/users/users.module.ts",
		"users.module"
	],
	"./views/setting/years/years.module": [
		"./src/app/views/setting/years/years.module.ts",
		"years.module"
	],
	"./views/theme/theme.module": [
		"./src/app/views/theme/theme.module.ts",
		"theme.module"
	],
	"./views/widgets/widgets.module": [
		"./src/app/views/widgets/widgets.module.ts",
		"widgets.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main